import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-common-pipeline-name',
  templateUrl: './help-common-pipeline-name.component.html'
})
export class HelpCommonPipelineNameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
